import React from 'react';
import InputTypesEnum from '../../../Enums/InputTypesEnum';
import { LiveInput, InputRow } from './inputsDemoHelpers';

function InputsDateTimeDemoComponent() {
  return (
    <div>
      <InputRow label='Date — calendar picker'>
        <LiveInput
          type={InputTypesEnum.Date}
          fieldName='demoDate'
          labelText='Start date'
        />
      </InputRow>
      <InputRow label='DateWithIndefinite — date picker with an open-ended option'>
        <LiveInput
          type={InputTypesEnum.DateWithIndefinite}
          fieldName='demoDateIndefinite'
          labelText='End date'
        />
      </InputRow>
      <InputRow label='Time — time picker'>
        <LiveInput
          type={InputTypesEnum.Time}
          fieldName='demoTime'
          labelText='Shop time'
          initialValue='09:30'
        />
      </InputRow>
    </div>
  );
}

export const inputsDateTimeDemo = {
  id: 'inputs-datetime',
  title: 'Date & time',
  category: 'Inputs',
  importPath: 'src/Elements/InputComponents/InputWithClear.js (type=Date / DateWithIndefinite / Time)',
  notes: [
    'Date and DateWithIndefinite use CaspianDatePicker; Time uses CaspianTimePickerInput.',
    'The eraser resets a date field to today (InputWithClearBase.defaultValue), not to blank.',
    'For a day that must stay timezone-independent, pass dateAsUtc — see CaspianDatePicker.utc.',
  ],
  snippet:
    "<InputWithClear\n  type={InputTypesEnum.Date}\n  fieldName='StartDate'\n  labelText='Start date'\n  value={value}\n  onChange={(fieldName, v) => setValue(v)}\n/>",
  render: InputsDateTimeDemoComponent,
};
